<!-- 常见问题解决方案 -->
<template>
    <div id="qa" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>帮助文档</el-breadcrumb-item>
                <el-breadcrumb-item>用户帮助文档</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <el-button type="primary" size="small" icon="el-icon-plus" class="search-btn" @click="openDialog(0)" v-if="permission.新增">新增</el-button>
            <div class="search-ctn-right">
                <div class="search-name">问题类型:</div>
                <el-select
                        size="small"
                        class="search-item"
                        @change="chooseQType"
                        v-model="searchData.QType"
                        placeholder="请选择">
                    <el-option
                            v-for="item in QType"
                            :key="item.TKey"
                            :label="item.TValue"
                            :value="item.TKey">
                    </el-option>
                </el-select>
                <div class="search-name">问题:</div>
                <el-select
                        size="small"
                        class="search-item"
                        v-model="searchData.Id"
                        placeholder="请选择">
                    <el-option
                            v-for="item in QTitle"
                            :key="item.Id"
                            :label="item.Question"
                            :value="item.Id">
                    </el-option>
                </el-select>
                <el-button type="primary" size="small" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
                <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="qa-ctn" v-for="item in tableData" :key="item.Id">
            <div class="qa-title">
                <p>{{item.Question}}</p>
                <div class="article-ops">
                    <el-button type="primary" size="mini" round @click="openDialog(1,item)" v-if="permission.编辑">编辑</el-button>
                    <el-button size="mini" round @click="del(item)" v-if="permission.删除">删除</el-button>
                </div>
            </div>
            <div class="qa-content" v-html="item.Answer"></div>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                :before-close="clearDialog"
                width="70%">
            <div class="dialog-main">
                <el-form :model="formData" :rules="rules" ref="formData" label-width="150px">
                    <el-form-item label="问题类型" prop="TypeId">
                        <el-select v-model="formData.TypeId" placeholder="请选择">
                            <el-option
                                    v-for="item in QType"
                                    :key="item.TKey"
                                    :label="item.TValue"
                                    :value="item.TKey">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="问题标题" prop="Question">
                        <el-input v-model.trim="formData.Question"></el-input>
                    </el-form-item>
                    <el-form-item label="是否热门">
                        <el-switch
                                v-model="formData.IsHot"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="内容" prop="Answer">
                        <quillEditor
                                v-model="formData.Answer"
                                ref="myQuillEditor"
                                :options="editorOption"
                                @blur="onEditorBlur($event)"
                                @focus="onEditorFocus($event)"
                                @ready="onEditorReady($event)"
                        >
                        </quillEditor>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="submitForm()">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>
<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import {quillEditor} from 'vue-quill-editor'
    import quillConfig from '../../../assets/js/quill-config.js'

    export default {
        name: 'qa',
        components: {
            quillEditor
        },
        data() {
            return {
                editData:{}, // 当前正在编辑的数据
                dialogTitle:'新增',
                dialogType:0,  // 0 新增 1 编辑
                dialogVisible:false,  // 是否显示dialog
                content: '',  // 富文本编辑器内容
                editorOption: quillConfig, // 富文本编辑器配置
                options: [],
                QTitle:[],
                QType:[],
                searchData: {
                    Id:null,
                    QType:null,
                    page:1,
                    limit:10,
                },
                formData:{
                    "Id": "",
                    "TypeId": "",
                    "Question": "",
                    "Answer": "",
                    "IsHot": false
                },
                tableData: [],
                tableDataLength:0,
                rules:{
                    QType: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    Question: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    Answer: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                },
                permission:{}
            }
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill
            }
        },
        mounted() {
            this.GetTypeConfig()
            this.getTableData();
            this.$util.getPermission('常见问题解决方案').then((res)=>{
                this.permission = res
            })
        },
        methods: {
            // 关闭弹窗
            clearDialog(){
                this.$refs.formData.clearValidate();
                this.dialogVisible = false// dialog显隐
            },
            // 问题类型接口
            GetTypeConfig(){
                this.axios.get('/Common/GetTypeConfig',{
                    // 常见问题类型：UsefulFileQType
                    // 用户帮助文档类型：UserHelpQType
                    params:{
                        TypeCodes :'UserHelpQType'
                    }
                })
                    .then((response)=> {
                        let data = response.data.data.UserHelpQType
                        this.QType = data
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            // 选中问题类型出发
            chooseQType(value){
                this.axios.get('/Helps/GetUserHelpDocByType',{
                    params: {
                        QType:value
                    }
                })
                    .then((response)=> {
                        this.QTitle = response.data.data
                        this.searchData.Id = ''
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            // 提交数据
            submitForm() {
                let formName = 'formData';
                this.$refs[formName].validate((valid) => {
                    let _formData = {...this.formData}
                    let url = ''
                    if (valid) {
                        url = '/Helps/EditHelpDoc'
                        this.axios.post(url,_formData)
                            .then((response)=> {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功!'
                                });
                                this.getTableData()
                            })
                            .catch((error)=>{
                                console.log(error);
                            });

                        this.dialogVisible = false
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 重置表单
            resetForm() {
                let formName = 'formData';
                this.$refs[formName].resetFields();
            },
            // 获取数据
            getTableData(){
                this.axios.get('/Helps/LoadUserHelpDoc',{
                    params: this.searchData
                })
                    .then((response)=> {
                        this.tableData = response.data.data
                        this.tableDataLength = response.data.count
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            // 点击编辑按钮
            openDialog(type,item){
                this.dialogType = type
                if (type == 0){
                    this.dialogTitle = '新增'
                }
                else {
                    if (item){
                        this.formData = item
                    }
                    this.dialogTitle = '编辑'
                }
                this.dialogVisible = true
            },
            // 编辑处理
            editHandle(){
                this.dialogVisible = false
            },
            onEditorBlur(quill) {
                console.log('editor blur!', quill)
            },
            onEditorFocus(quill) {
                console.log('editor focus!', quill)
            },
            onEditorReady(quill) {
                console.log('editor ready!', quill)
            },
            onEditorChange({quill, html, text}) {
                console.log('editor change!', quill, html, text)
                this.content = html
            },
            //删除文章
            del(item){
                this.$confirm('确定删除此文章?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.post('/Helps/DeleteUserHelpDoc?ids='+item.Id)
                        .then((response)=> {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getTableData()
                        })
                        .catch((error)=>{
                            console.log(error);
                        });
                })
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            resetSearch(){
                this.searchData = {
                    QTitle:null,
                    QType:null,
                }
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            }
        }
    }
</script>
<style lang="less" scoped>
    .qa-title {
        position: relative;
        text-align: center;
        line-height: 60px;
        font-size: @font-md;
    }

    .article-ops {
        position: absolute;
        top: 0;
        right: 0;
    }

    .qa-ctn {
        min-height: 200px;
        max-width: 1000px;
        margin: 30px auto 0;
        border: 1px solid @border1Color;
        padding: 20px;
        border-radius:10px;
    }
    .qa-content {
        img {
            max-width: 300px;
        }
    }
    .search-ctn {
        justify-content: space-between;
        .search-ctn-right {
            display: flex;
            align-items: center;
        }
    }
    .dialog-main {
        max-height: 500px;
        overflow: auto;
    }
</style>
